import{isFunction as e,defaultsDeep as t,isObject as a,sortBy as o,isEmpty as i,reduce as n,pick as r,find as s,map as l,range as d,isString as p,defaults as g,upperFirst as m,omit as h,toPairs as c,indexOf as u,cloneDeep as b,reject as f,get as y,omitBy as w,uniq as k,keys as x,flatten as S,values as C,difference as v,kebabCase as M}from"lodash";import N from"tinycolor2";import z,{css as $,ThemeContext as R,createGlobalStyle as E,ThemeProvider as T}from"styled-components";import I,{useContext as A}from"react";function O({theme:o,defaults:i,override:n}){return e(n)?t(n({defaults:i,theme:o}),i):a(n)?t(n,i):i}function F(e,t){e:for(let a=0;a<e.length;a+=1){const o=e[a];for(let e=0;e<o.deps.length;e+=1)if(!s(t,(({name:t})=>o.deps[e]===t)))continue e;return a}const a=e.map((e=>`${e.name}: ${e.deps.join(", ")}`)).join("; ");throw Error(`The following theme settings have unmet dependencies: ${a}`)}const P=["gray","blue","indigo","purple","pink","red","orange","yellow","green","teal","cyan"],j={name:"colors",deps:[],defaults:{white:"#ffffff",gray:"#B0B9C9",black:"#000000",blue:"#3978EC",indigo:"#6610f2",purple:"#6f42c1",pink:"#d63384",red:"#DE7283",orange:"#fd7e14",yellow:"#EFC174",green:"#6AD193",teal:"#20c997",cyan:"#17a2b8"},apply:O};function H({name:e,startColor:t,step:a=8}){const o=N(t),i=l(d(5,1,-1),(e=>o.clone().lighten(e*a).toRgbString())),r=l(d(1,5),(e=>o.clone().darken(e*a).toRgbString()));return{...n(i,((t,a,o)=>(t[`${e}${o+1}00`]=a,t)),{}),[`${e}500`]:o.toRgbString(),...n(r,((t,a,o)=>(t[`${e}${o+6}00`]=a,t)),{})}}const q={name:"colorShades",deps:["colors"],defaults:({colors:e})=>n(P,((t,a)=>({...t,...H({name:a,startColor:e[a]})})),{}),apply:O},W=["primary","secondary","success","info","warning","danger","light","dark","fg","bg"],B={name:"themeColors",deps:["colors","colorShades"],defaults:({colors:e,colorShades:t})=>{const a=t.gray100,o=t.gray900;return{primary:e.blue,secondary:e.gray,success:e.green,info:e.cyan,warning:t.orange400,danger:t.red500,light:a,dark:o,bg:a,fg:o}},apply:O},D={name:"themeColorShades",deps:["colors","colorShades","themeColors"],defaults:({themeColors:e})=>n(W,((t,a)=>({...t,...H({name:a,startColor:e[a]})})),{}),apply:O};function L(e,t){const a=N(t),o=l(d(1,10),(e=>a.clone().setAlpha(e/10).toString()));return n(o,((t,a,o)=>(t[`${e}${(o+1).toString()}0`]=a,t)),{})}const U={name:"themeColorOpacities",deps:["themeColors"],defaults:({themeColors:e})=>n(W,((t,a)=>({...t,...L(a,e[a])})),{}),apply:O},V={name:"subtleColors",deps:["colors","colorShades","themeColors","themeColorShades"],defaults:({themeColorShades:e})=>({primary:e.primary300,secondary:e.secondary300,success:e.success300,info:e.info300,warning:e.warning300,danger:e.danger300,light:e.light600,dark:e.dark300,bg:e.bg600,fg:e.fg300}),apply:O},G={name:"darkColors",deps:["colors","colorShades","themeColors","themeColorShades"],defaults:({themeColorShades:e})=>({primary:e.primary700,secondary:e.secondary700,success:e.success700,info:e.info700,warning:e.warning700,danger:e.danger700,light:e.light100,dark:e.dark900,bg:e.bg900,fg:e.fg100}),apply:O},_={name:"body",deps:["colors","colorShades","themeColors","themeColorShades","subtleColors","darkColors"],defaults:({themeColors:e})=>({bg:e.bg,textColor:e.fg}),apply:O};const K={name:"spacing",deps:[],defaults:(J=1,{basis:J,...n({0:0,1:J/4,2:J/2,3:J,4:1.5*J,5:3*J},((e,t,a)=>({...e,[`${a}`]:`${t}rem`})),{})}),apply:O};var J;const Q={name:"breakpoints",deps:[],defaults:{xs:0,sm:576,md:768,lg:992,xl:1200,xxl:1400},apply:O},X={name:"borders",deps:["colorShades","themeColors"],defaults:({colorShades:e})=>({xs:{borderWidth:"1px",borderStyle:"solid",borderColor:e.gray300,borderRadius:"0.2rem"},md:{borderWidth:"2px",borderStyle:"solid",borderRadius:"0.5rem"},lg:{borderRadius:"0.3rem"}}),apply:O};var Y;!function(e){e[e.sans=0]="sans",e[e.serif=1]="serif",e[e.mono=2]="mono"}(Y||(Y={}));const Z={name:"fontStacks",deps:[],defaults:{fallbackFace:"sans",sans:["-apple-system","BlinkMacSystemFont",'"Segoe UI"',"Roboto",'"Helvetica Neue"',"Arial","sans-serif",'"Apple Color Emoji"','"Segoe UI Emoji"','"Segoe UI Symbol"'],serif:["Cambria",'"Hoefler Text"',"Utopia",'"Liberation Serif"','"Nimbus Roman No9 L Regular"',"Times",'"Times New Roman"',"serif"],mono:["SFMono-Regular","Menlo","Monaco","Consolas",'"Liberation Mono"','"Courier New"',"monospace"]},apply:e=>{if(a(e.override)){const t=n(e.override,((e,t,a)=>(p(t)?e[a]=[t]:e[a]=t,e)),{});e.override=t}return O(e)}};var ee;!function(e){e[e.heading=0]="heading",e[e.display=1]="display",e[e.default=2]="default",e[e.code=3]="code",e[e.quote=4]="quote",e[e.button=5]="button",e[e.anchor=6]="anchor",e[e.link=7]="link"}(ee||(ee={}));const te={name:"fontVariants",deps:["fontStacks","body"],defaults:({fontStacks:e,body:t})=>{const a=e[e.fallbackFace],o={stack:a,weight:500,style:"normal",lineHeight:"1.5",letterSpacing:"0"},i={heading:{stack:a,lineHeight:"1.3",letterSpacing:"1.2px"},display:{stack:a,weight:300,lineHeight:"1.3",letterSpacing:"1.2px"},default:{},code:{stack:e.mono},quote:{stack:e.serif},button:{},anchor:{},link:{}};return n(i,((e,t,a)=>(e[a]=g(t,o),e)),{})},apply:O};var ae;!function(e){e[e.h1=0]="h1",e[e.h2=1]="h2",e[e.h3=2]="h3",e[e.h4=3]="h4",e[e.h5=4]="h5",e[e.h6=5]="h6",e[e.a=6]="a",e[e.display1=7]="display1",e[e.display2=8]="display2",e[e.display3=9]="display3",e[e.display4=10]="display4",e[e.default=11]="default",e[e.button=12]="button",e[e.listItem=13]="listItem",e[e.small=14]="small",e[e.large=15]="large",e[e.code=16]="code"}(ae||(ae={}));const oe={name:"fontTags",deps:["fontVariants"],defaults:({fontVariants:e})=>({h1:{...e.heading,size:"3rem"},h2:{...e.heading,size:"2.5rem"},h3:{...e.heading,size:"1.75rem"},h4:{...e.heading,size:"1.5rem"},h5:{...e.heading,size:"1.25rem"},h6:{...e.heading,size:"1rem"},a:{...e.default,size:"1rem"},display1:{...e.display,size:"6rem"},display2:{...e.display,size:"5.5rem"},display3:{...e.display,size:"4.5rem"},display4:{...e.display,size:"3.5rem"},default:{...e.default,size:"1rem"},button:{...e.button,size:"1.25rem"},listItem:{...e.default,size:"100%"},small:{...e.default,size:"80%"},large:{...e.default,size:"120%"},code:{...e.code,size:"1rem"}}),apply:O};var ie;!function(e){e[e.container=0]="container",e[e.heading=1]="heading",e[e.p=2]="p",e[e.pre=3]="pre",e[e.kbd=4]="kbd",e[e.figure=5]="figure",e[e.table=6]="table",e[e.label=7]="label",e[e.legend=8]="legend",e[e.ol=9]="ol",e[e.ul=10]="ul",e[e.li=11]="li",e[e.address=12]="address",e[e.dt=13]="dt",e[e.dd=14]="dd",e[e.blockquote=15]="blockquote"}(ie||(ie={}));const ne={name:"blockElements",deps:["colors","themeColors","themeColorShades","spacing","body","themeColorOpacities"],defaults:({spacing:e,themeColorOpacities:t,body:a})=>{const o={mt:e[0],mb:e[3]},i=n(ie,((e,t,a)=>(!1!==isNaN(Number(a))&&(e[a]={...o}),e)),{});return i.container.mb=e[0],i.container.textColor=a.textColor,i.container.bg=a.bg,i.ul.pl=e[4],i.ol.pl=e[4],i.label.mb=e[1],i.pre={...o,bg:t.bg50,px:e[4],py:e[4]},i.kbd={...o,bg:t.bg50,px:e[2],py:e[2]},i.dd.ml=e[0],i.dd.mb=e[2],i.figure.mx=e[0],i},apply:O},re={name:"globalStyles",deps:["colors","body","spacing","colorShades","themeColors","themeColorShades","borders","fontTags","blockElements"],defaults:({blockElements:e,fontTags:t})=>({xs:{container:e.container,heading:e.heading,p:e.p,pre:e.pre,kbd:e.kbd,figure:e.figure,table:e.table,label:e.label,legend:e.legend,ol:e.ol,ul:e.ul,li:e.li,address:e.address,dt:e.dt,dd:e.dd,blockquote:e.blockquote,h1:t.h1,h2:t.h2,h3:t.h3,h4:t.h4,h5:t.h5,h6:t.h6,a:t.a,display1:t.display1,display2:t.display2,display3:t.display3,display4:t.display4,default:t.default,button:t.button,listItem:t.listItem,small:t.small,large:t.large,code:t.code}}),apply:O},se=["xs","sm","md","lg","xl","xxl"],le=[...se,...se.map((e=>`lt${m(e)}`)),...se.map((e=>`${e}Only`))];const de=[j,q,B,D,U,V,G,_,K,Q,X,Z,te,oe,ne,re,{name:"mq",deps:["breakpoints"],defaults:({breakpoints:e})=>{let t;return n(se,((a,o)=>{if(a[o]=(...t)=>$`
            @media (min-width: ${e[o]}px) {
              ${$(...t)}
            }
          `,t){const i=`lt${m(o)}`,n=`${t}Only`,r=e[o]-1,s=e[t];a[i]=(...e)=>$`
            @media (max-width: ${r}px) {
              ${$(...e)}
            }
          `,a[n]=(...e)=>$`
            @media (min-width: ${s}px) and (max-width: ${r}px) {
              ${$(...e)}
            }
          `}return t=o,a}),{})},apply:O},{name:"contrastColor",deps:["themeColors"],defaults:e=>({color:t})=>N(t).isDark()?e.themeColors.light:e.themeColors.dark,apply:O}];function pe(t={}){return function({extensions:t,settings:a={}}){const s=[...t],l=o([...s],(e=>e.name)),d=[];for(;!i(l);){const e=F(l,d);d.push(l[e]),l.splice(e,1)}const p=n(d,((t,o)=>{const i=o.name,n=o.deps,s=r(t,n);let l=o.defaults;e(l)&&(l=l(t));const d=o.apply,p=a[i];return t[i]=d({theme:s,defaults:l,override:p}),t}),{});return p}({extensions:de,settings:t})}const ge=$`
  /**
  * Change from 'box-sizing: content-box' so that 'width' is not affected by 'padding' or 'border'.
  */

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  /**
  * 1. correct the line height in all browsers.
  * 2. prevent adjustments of font size after orientation changes in ios.
  */

  html {
    line-height: 1.15; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
  }

  /**
  * 1. Remove the margin in all browsers.
  * 2. Prevent adjustments of font size after orientation changes in iOS.
  * 3. Change the default tap highlight to be completely transparent in iOS.
  */

  body {
    margin: 0; /* 1 */
    -webkit-text-size-adjust: 100%; /* 2 */
    -webkit-tap-highlight-color: rgba($black, 0); /* 3 */
  }

  /**
  * Render the 'main' element consistently in IE.
  */

  main {
    display: block;
  }

  /**
  * 1. Add the correct box sizing in Firefox.
  * 2. Show the overflow in Edge and IE.
  */

  hr {
    box-sizing: content-box; /* 1 */
    height: 0; /* 1 */
    overflow: visible; /* 2 */
  }

  /**
  * Future-proof rule: in browsers that support :focus-visible, suppress the focus outline
  * on elements that programmatically receive focus but wouldn't normally show a visible
  * focus outline. In general, this would mean that the outline is only applied if the
  * interaction that led to the element receiving programmatic focus was a keyboard interaction,
  * or the browser has somehow determined that the user is primarily a keyboard user and/or
  * wants focus outlines to always be presented.
  * See https://developer.mozilla.org/en-US/docs/Web/CSS/:focus-visible
  * and https://developer.paciellogroup.com/blog/2018/03/focus-visible-and-backwards-compatibility/
  */

  [tabindex='-1']:focus:not(:focus-visible) {
    outline: 0 !important;
  }

  /**
  * 1. Change the font styles in all browsers.
  * 2. Remove the margin in Firefox and Safari.
  */

  button,
  input,
  optgroup,
  select,
  textarea {
    font-family: inherit; /* 1 */
    font-size: 100%; /* 1 */
    line-height: 1.15; /* 1 */
    margin: 0; /* 2 */
  }

  /**
  * Show the overflow in IE.
  * 1. Show the overflow in Edge.
  */

  button,
  input {
    /* 1 */
    overflow: visible;
  }

  /**
  * Remove the inheritance of text transform in Edge, Firefox, and IE.
  * 1. Remove the inheritance of text transform in Firefox.
  */

  button,
  select {
    /* 1 */
    text-transform: none;
  }

  /**
  * Correct the inability to style clickable types in iOS and Safari.
  */

  button,
  [type='button'],
  [type='reset'],
  [type='submit'] {
    -webkit-appearance: button;
  }

  /**
  * Remove the inner border and padding in Firefox.
  */

  button::-moz-focus-inner,
  [type='button']::-moz-focus-inner,
  [type='reset']::-moz-focus-inner,
  [type='submit']::-moz-focus-inner {
    border-style: none;
    padding: 0;
  }

  /**
  * Correct the padding in Firefox.
  */

  fieldset {
    padding: 0.35em 0.75em 0.625em;
  }

  /**
  * 1. Correct the text wrapping in Edge and IE.
  * 2. Correct the color inheritance from 'fieldset' elements in IE.
  * 3. Remove the padding so developers are not caught out when they zero out
  *    'fieldset' elements in all browsers.
  */

  legend {
    box-sizing: border-box; /* 1 */
    color: inherit; /* 2 */
    display: table; /* 1 */
    max-width: 100%; /* 1 */
    padding: 0; /* 3 */
    white-space: normal; /* 1 */
  }

  /**
  * Add the correct vertical alignment in Chrome, Firefox, and Opera.
  */

  progress {
    vertical-align: baseline;
  }

  /**
  * Remove the default vertical scrollbar in IE 10+.
  */

  textarea {
    overflow: auto;
  }

  /**
  * 1. Add the correct box sizing in IE 10.
  * 2. Remove the padding in IE 10.
  */

  [type='checkbox'],
  [type='radio'] {
    box-sizing: border-box; /* 1 */
    padding: 0; /* 2 */
  }

  /**
  * Correct the cursor style of increment and decrement buttons in Chrome.
  */

  [type='number']::-webkit-inner-spin-button,
  [type='number']::-webkit-outer-spin-button {
    height: auto;
  }

  /**
  * 1. Correct the odd appearance in Chrome and Safari.
  * 2. Correct the outline style in Safari.
  */

  [type='search'] {
    -webkit-appearance: textfield; /* 1 */
    outline-offset: -2px; /* 2 */
  }

  /**
  * Remove the inner padding in Chrome and Safari on macOS.
  */

  [type='search']::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
  * 1. Correct the inability to style clickable types in iOS and Safari.
  * 2. Change font properties to 'inherit' in Safari.
  */

  ::-webkit-file-upload-button {
    -webkit-appearance: button; /* 1 */
    font: inherit; /* 2 */
  }

  /*
  * Add the correct display in Edge, IE 10+, and Firefox.
  */

  details {
    display: block;
  }

  /*
  * Add the correct display in all browsers.
  */

  summary {
    display: list-item;
  }

  /**
  * Add the correct display in IE 10+.
  */

  template {
    display: none;
  }

  /**
  * Add the correct display in IE 10.
  */

  [hidden] {
    display: none;
  }

  /**
  * Abbreviations
  * 1. Duplicate behavior to the data-* attribute for our tooltip plugin
  * 2. Add the correct text decoration in Chrome, Edge, Opera, and Safari.
  * 3. Add explicit cursor to indicate changed behavior.
  * 4. Prevent the text-decoration to be skipped.
  */

  abbr[title],
  abbr[data-original-title] /* 1 */ {
    text-decoration: underline; /* 2 */
    text-decoration: underline dotted; /* 2 */
    cursor: help; // 3
    text-decoration-skip-ink: none; /* 4 */
  }

  /**
  * address
  */

  address {
    font-style: normal;
    line-height: inherit;
  }

  /**
  * definition tags
  */
  dt {
    font-weight: $dt-font-weight;
  }

  /**
  * Sub and Sup
  * Prevent 'sub' and 'sup' elements from affecting the line height in all
  * browsers
  */

  sub,
  sup {
    position: relative;
    line-height: 0;
    vertical-align: baseline;
  }

  sub {
    bottom: -0.25em;
  }

  sup {
    top: -0.5em;
  }

  /**
  * anchors
  * Undo these styles for placeholder links/named anchors (without href).
  * It would be more straightforward to just use a[href] in previous block, but that
  * causes specificity issues in many other styles that are too complex to fix.
  * See https://github.com/twbs/bootstrap/issues/19402
  */

  a:not([href]):not([class]) {
    &,
    &:hover {
      color: inherit;
      text-decoration: none;
    }
  }

  /**
  * code
  *
  * 1. Don't allow content to break outside
  * 2. Disable auto-hiding scrollbar in legacy Edge to avoid overlap,
  *    making it impossible to interact with the content
  */

  pre {
    display: block;
    overflow: auto; // 1
    -ms-overflow-style: scrollbar; // 2

    // Account for some code outputs that place code tags in pre tags
    code {
      color: inherit;
      word-break: normal;
    }
  }

  code {
    word-wrap: break-word;

    /**
    * Streamline the style when inside anchors to avoid broken underline and
    * more
    */
    a > & {
      color: inherit;
    }
  }

  kbd {
    kbd {
      padding: 0;
    }
  }

  /**
  * Images and content
  */

  img,
  svg {
    vertical-align: middle;
  }

  /**
  * Tables
  */

  table {
    caption-side: bottom;
    border-collapse: collapse;
  }

  caption {
    text-align: left;
  }

  /**
  * 1. Matches default '<td>' alignment by inheriting 'text-align'.
  * 2. Fix alignment for Safari
  */

  th {
    text-align: inherit; /* 1 */
    text-align: -webkit-match-parent; /* 2 */
  }

  thead,
  tbody,
  tfoot,
  tr,
  td,
  th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
  }

  /**
  * Forms
  * 1. Allow labels to use 'margin' for spacing.
  */

  label {
    display: inline-block; /* 1 */
  }

  /**
  * Remove the default 'border-radius' that macOS Chrome adds.
  * See https://github.com/twbs/bootstrap/issues/24093
  */

  button {
    border-radius: 0;
  }

  /**
  * Work around a Firefox bug where the transparent 'button' background
  * results in a loss of the default 'button' focus styles.
  * Credit https://github.com/suitcss/base/
  */

  button:focus {
    outline: 1px dotted;
    outline: 5px auto -webkit-focus-ring-color;
  }

  /**
  * 1. Remove the margin in Firefox and Safari
  */

  input,
  button,
  select,
  optgroup,
  textarea {
    margin: 0; /* 1 */
    font-family: inherit;
    line-height: inherit;
  }

  /**
  * Show the overflow in Edge
  */

  button,
  input {
    overflow: visible;
  }

  /**
  * Remove the inheritance of text transform in Firefox
  */

  button,
  select {
    text-transform: none;
  }

  /**
  * Set the cursor for non-'<button>' buttons
  *
  * Details at https://github.com/twbs/bootstrap/pull/30562
  */

  [role='button'] {
    cursor: pointer;
  }

  /**
  * Remove the inheritance of word-wrap in Safari.
  * See https://github.com/twbs/bootstrap/issues/24990
  */

  select {
    word-wrap: normal;
  }

  /**
  * Remove the dropdown arrow in Chrome from inputs built with datalists.
  * See https://stackoverflow.com/a/54997118
  */

  [list]::-webkit-calendar-picker-indicator {
    display: none;
  }

  /**
  * 1. Prevent a WebKit bug where (2) destroys native 'audio' and 'video'
  *    controls in Android 4.
  * 2. Correct the inability to style clickable types in iOS and Safari.
  * 3. Opinionated: add "hand" cursor to non-disabled button elements.
  */

  button,
  [type="button"], /* 1 */
  [type="reset"],
  [type="submit"] {
    -webkit-appearance: button; /* 2 */

    &:not(:disabled) {
      cursor: pointer; /* 3 */
    }
  }

  /**
  * 1. Textareas should really only resize vertically so they don't break their
  *    (horizontal) containers.
  */

  textarea {
    resize: vertical; /* 1 */
  }

  /**
  * 1. Browsers set a default 'min-width: min-content;' on fieldsets,
  *    unlike e.g. '<div>'s, which have 'min-width: 0;' by default.
  *    So we reset that to ensure fieldsets behave more like a standard block element.
  *    See https://github.com/twbs/bootstrap/issues/12359
  *    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements
  * 2. Reset the default outline behavior of fieldsets so they don't affect page layout.
  */

  fieldset {
    min-width: 0; /* 1 */
    padding: 0; /* 2 */
    margin: 0; /* 2 */
    border: 0; /* 2 */
  }

  /**
  * 1. By using 'float: left', the legend will behave like a block element.
  *    This way the border of a fieldset wraps around the legend if present.
  * 2. Correct the text wrapping in Edge.
  * 3. Fix wrapping bug.
  *    See https://github.com/twbs/bootstrap/issues/29712
  */

  legend {
    float: left; /* 1 */
    width: 100%;
    padding: 0;
    line-height: inherit;
    white-space: normal; /* 2 */

    + * {
      clear: left; /* 3 */
    }
  }

  /**
  * Fix height of inputs with a type of datetime-local, date, month, week, or time
  * See https://github.com/twbs/bootstrap/issues/18842
  */

  ::-webkit-datetime-edit-fields-wrapper,
  ::-webkit-datetime-edit-text,
  ::-webkit-datetime-edit-minute,
  ::-webkit-datetime-edit-hour-field,
  ::-webkit-datetime-edit-day-field,
  ::-webkit-datetime-edit-month-field,
  ::-webkit-datetime-edit-year-field {
    padding: 0;
  }

  ::-webkit-inner-spin-button {
    height: auto;
  }

  /**
  * 1. Correct the outline style in Safari.
  * 2. This overrides the extra rounded corners on search inputs in iOS so that our
  *    '.form-control' class can properly style them. Note that this cannot simply
  *    be added to '.form-control' as it's not specific enough. For details, see
  *    https://github.com/twbs/bootstrap/issues/11586.
  */

  [type='search'] {
    outline-offset: -2px; // 1
    -webkit-appearance: textfield; // 2
  }

  /**
  * Remove the inner padding in Chrome and Safari on macOS.
  */

  ::-webkit-search-decoration {
    -webkit-appearance: none;
  }

  /**
  * Remove padding around color pickers in webkit browsers
  */

  ::-webkit-color-swatch-wrapper {
    padding: 0;
  }

  /**
  * 1. Change font properties to 'inherit' in Safari.
  * 2. Correct the inability to style clickable types in iOS and Safari.
  */

  ::-webkit-file-upload-button {
    font: inherit; /* 1 */
    -webkit-appearance: button; /* 2 */
  }

  /**
  * Correct element displays
  */

  output {
    display: inline-block;
  }

  /**
  * Remove border from iframe
  */

  iframe {
    border: 0;
  }

  /**
  * Summary
  *
  * 1. Add the correct display in all browsers
  */

  summary {
    display: list-item; /* 1 */
    cursor: pointer;
  }

  /**
  * Progress
  *
  * Add the correct vertical alignment in Chrome, Firefox, and Opera.
  */

  progress {
    vertical-align: baseline;
  }

  /**
  * Hidden attribute
  *
  * Always hide an element with the 'hidden' HTML attribute.
  */

  [hidden] {
    display: none !important;
  }
`;function me({theme:e,defaultComponentTheme:a,extendTheme:i,applyThemeBreakpoint:n}){const s=function({defaultComponentTheme:e,extendTheme:a}){const o=r(a,le),i=h(a,le),n=e.xs,s=g(o.xs||{},i,n);return t({...o,xs:s},h(e,"xs"))}({defaultComponentTheme:a,extendTheme:i}),d=o(c(s),(([e])=>u(le,e)));return l(d,(([t,a])=>()=>e.mq[t]`${n(e,a)}`))}function he(e){return/^_/.test(e)}function ce({props:t,helperMethods:a,root:o}){return n(t,((t,i,n)=>{if(o||(o=t),he(n))t[n]=ce({props:i,helperMethods:a,root:o});else if(e(i)){const e=i;t[n]=e({...o,...a})}else t[n]=i;return t}),{})}function ue({theme:t,computedProps:a,props:o,apply:i,helperMethods:r,componentProps:s}){return n(i,((i,n,l)=>{if(!o[l])return i;if(e(n)){const e=n({...a,...o,theme:t,componentProps:s,...r});i.push(e)}else i.push(n);return i}),[])}function be({theme:e,props:t,apply:a,cascade:o={},helperMethods:i,componentProps:r}){const s=b(t),l=f(Object.keys(s),he);for(const e of Object.keys(o))if(s[e])for(const t of Object.keys(o[e])){s[t]||(s[t]={});const a=o[e][t];if(!y(s,[t,e])){(s[t]||{})[e]=a}}const d=ce({props:s,helperMethods:i}),p=w(d,((e,t)=>he(t))),g=ue({theme:e,props:p,computedProps:d,apply:a,helperMethods:i,componentProps:r}),m=k([...x(s).filter(he),...S(C(l).map((e=>x(e))))]);return[...g,...n(m,((t,o)=>{const n=o.replace(/_/,":"),s=d[o],l=ue({theme:e,props:{...s},computedProps:d,apply:a,helperMethods:i,componentProps:r}),p=$`
        ${n} {
          ${l}
        }
      `;return t.push(...p),t}),[])]}function fe({defaultVariants:e,states:a=[],extend:o,compose:i}){return n=>{const s=y(n,"theme",A(R)),l=Object.keys(e||{});let d=t(r(n,l),e);const p={theme:s,contrastColor:e=>function({themeColors:e,color:t}){return N(t).isDark()?e.light:e.dark}({color:e,themeColors:s.themeColors})},{Component:g,defaultStyleMapping:m,mapPropsToStyle:h,cascadeStateProps:c={},variantMapping:u={}}=i({...p,variant:d});d=t(d,e);const b=[...Object.keys(m.xs),...le,...a],f=r(n,b);for(const[,e]of Object.entries(u)){const a=e(d);m.xs=t(a,m.xs)}const w=v(Object.keys(n),[...b,...l]),k=r(n,w),x=me({theme:s,defaultComponentTheme:m,extendTheme:f,applyThemeBreakpoint:(e,t)=>be({theme:e,props:t,helperMethods:p,apply:{...h,...o?o(p):{}},cascade:c,componentProps:k})});return I.createElement(g,{componentCss:x,...k})}}const ye={stack:"font-family",weight:"font-weight",style:"font-style",size:"font-size",color:"color",lineHeight:"line-height",letterSpacing:"letter-spacing"};function we({tagName:e,tagMapping:t}){const a=n(t,((e,t,a)=>(t&&(e+=`${ye[a]}: ${t};`),e)),"");return $`
    ${e} {
      ${a}
    }
  `}const ke=["m","mt","mb","ml","mr","mx","my","p","pt","pb","pl","pr","px","py","opacity","textAlign","w","h","minW","minH","minSize","maxW","maxH","maxSize","verticalAlign","bg","bgSize","bgPos","bgRepeat","bgAttachment","area","textColor","border"],xe=[...ke,"alignItems","alignContent","alignSelf","justifyItems","justifyContent","justifySelf"],Se=[...xe,"wrap","flex","grow","shrink","basis","order"],Ce=[...xe,"gap","rowGap","columnGap","column","row","autoFlow","autoRows","autoColumns","templateRows","templateColumns","templateAreas"],ve={m:["margin"],mt:["marginTop"],mb:["marginBottom"],ml:["marginLeft"],mr:["marginRight"],mx:["marginLeft","marginRight"],my:["marginTop","marginBottom"],p:["padding"],pt:["paddingTop"],pb:["paddingBottom"],pl:["paddingLeft"],pr:["paddingRight"],px:["paddingLeft","paddingRight"],py:["paddingTop","paddingBottom"],w:["width"],h:["height"],minW:["minWidth"],minH:["minHeight"],maxW:["maxWidth"],maxH:["maxHeight"],bg:["backgroundColor"],bgRepeat:["backgroundRepeat"],bgAttachment:["backgroundAttachment"],bgPos:["backgroundPosition"],bgSize:["backgroundSize"],textColor:["color"],maxSize:["maxWidth","maxHeight"],minSize:["minWidth","minHeight"],wrap:["flexWrap"],grow:["flexGrow"],shrink:["flexShrink"],basis:["flexBasis"],column:["gridColumn"],row:["gridRow"]};function Me({tagName:e,tagMapping:t}){const a=n(t,((e,t,a)=>{if(t){e+=(ve[a]||[a]).map(M).map((e=>`${e}: ${t};`)).join("")}return e}),"");return $`
    ${e} {
      ${a}
    }
  `}const Ne=E`
  ${({componentCss:e})=>$`
    ${ge};
    ${e};
  `}
`,ze=({componentCss:e})=>I.createElement(Ne,{componentCss:e}),$e=fe({compose:({theme:e})=>({Component:ze,defaultStyleMapping:e.globalStyles,mapPropsToStyle:{container:({container:e})=>Me({tagMapping:e,tagName:"html,body"}),heading:({heading:e})=>Me({tagMapping:e,tagName:"h1,h2,h3,h4,h5,h6"}),p:({p:e})=>Me({tagMapping:e,tagName:"p"}),pre:({pre:e})=>Me({tagMapping:e,tagName:"pre"}),kbd:({kbd:e})=>Me({tagMapping:e,tagName:"kbd"}),figure:({figure:e})=>Me({tagMapping:e,tagName:"figure"}),table:({table:e})=>Me({tagMapping:e,tagName:"table"}),label:({label:e})=>Me({tagMapping:e,tagName:"label"}),legend:({legend:e})=>Me({tagMapping:e,tagName:"legend"}),ol:({ol:e})=>Me({tagMapping:e,tagName:"ol"}),ul:({ul:e})=>Me({tagMapping:e,tagName:"ul"}),li:({li:e})=>Me({tagMapping:e,tagName:"li"}),address:({address:e})=>Me({tagMapping:e,tagName:"address"}),dt:({dt:e})=>Me({tagMapping:e,tagName:"dt"}),dd:({dd:e})=>Me({tagMapping:e,tagName:"dd"}),blockquote:({blockquote:e})=>Me({tagMapping:e,tagName:"blockquote"}),h1:({h1:e})=>we({tagMapping:e,tagName:"h1"}),h2:({h2:e})=>we({tagMapping:e,tagName:"h2"}),h3:({h3:e})=>we({tagMapping:e,tagName:"h3"}),h4:({h4:e})=>we({tagMapping:e,tagName:"h4"}),h5:({h5:e})=>we({tagMapping:e,tagName:"h5"}),h6:({h6:e})=>we({tagMapping:e,tagName:"h6"}),a:({a:e})=>we({tagMapping:e,tagName:"a"}),display1:({display1:e})=>we({tagMapping:e,tagName:".display-1"}),display2:({display2:e})=>we({tagMapping:e,tagName:".display-2"}),display3:({display3:e})=>we({tagMapping:e,tagName:".display-3"}),display4:({display4:e})=>we({tagMapping:e,tagName:".display-4"}),default:e=>we({tagMapping:e.default,tagName:"body"}),button:({button:e})=>we({tagMapping:e,tagName:"button"}),listItem:({listItem:e})=>we({tagMapping:e,tagName:"li"}),small:({small:e})=>we({tagMapping:e,tagName:"small"}),large:({large:e})=>we({tagMapping:e,tagName:".large"}),code:({code:e})=>we({tagMapping:e,tagName:"pre,code,kbd,samp"})}})}),Re=z.div`
  ${({componentCss:e})=>$`
      ${e}
    `};
`,Ee=({componentCss:e,theme:t,children:a,...o})=>I.createElement(T,{theme:t},I.createElement(Re,{componentCss:e,...o},a)),Te=fe({compose:({theme:e})=>({Component:Ee,defaultStyleMapping:e.globalStyles,mapPropsToStyle:{container:({container:e})=>Me({tagMapping:e,tagName:"&"}),heading:({heading:e})=>Me({tagMapping:e,tagName:"h1,h2,h3,h4,h5,h6"}),p:({p:e})=>Me({tagMapping:e,tagName:"p"}),pre:({pre:e})=>Me({tagMapping:e,tagName:"pre"}),kbd:({kbd:e})=>Me({tagMapping:e,tagName:"kbd"}),figure:({figure:e})=>Me({tagMapping:e,tagName:"figure"}),table:({table:e})=>Me({tagMapping:e,tagName:"table"}),label:({label:e})=>Me({tagMapping:e,tagName:"label"}),legend:({legend:e})=>Me({tagMapping:e,tagName:"legend"}),ol:({ol:e})=>Me({tagMapping:e,tagName:"ol"}),ul:({ul:e})=>Me({tagMapping:e,tagName:"ul"}),li:({li:e})=>Me({tagMapping:e,tagName:"li"}),address:({address:e})=>Me({tagMapping:e,tagName:"address"}),dt:({dt:e})=>Me({tagMapping:e,tagName:"dt"}),dd:({dd:e})=>Me({tagMapping:e,tagName:"dd"}),blockquote:({blockquote:e})=>Me({tagMapping:e,tagName:"blockquote"}),h1:({h1:e})=>we({tagMapping:e,tagName:"h1"}),h2:({h2:e})=>we({tagMapping:e,tagName:"h2"}),h3:({h3:e})=>we({tagMapping:e,tagName:"h3"}),h4:({h4:e})=>we({tagMapping:e,tagName:"h4"}),h5:({h5:e})=>we({tagMapping:e,tagName:"h5"}),h6:({h6:e})=>we({tagMapping:e,tagName:"h6"}),a:({a:e})=>we({tagMapping:e,tagName:"a"}),display1:({display1:e})=>we({tagMapping:e,tagName:".display-1"}),display2:({display2:e})=>we({tagMapping:e,tagName:".display-2"}),display3:({display3:e})=>we({tagMapping:e,tagName:".display-3"}),display4:({display4:e})=>we({tagMapping:e,tagName:".display-4"}),default:e=>we({tagMapping:e.default,tagName:"body"}),button:({button:e})=>we({tagMapping:e,tagName:"button"}),listItem:({listItem:e})=>we({tagMapping:e,tagName:"li"}),small:({small:e})=>we({tagMapping:e,tagName:"small"}),large:({large:e})=>we({tagMapping:e,tagName:".large"}),code:({code:e})=>we({tagMapping:e,tagName:"pre,code,kbd,samp"})}})});export{xe as AlignedContainerProps,ie as BlockElements,ke as ContainerProps,Se as FlexContainerProps,$e as GlobalStyles,Ce as GridContainerProps,Te as SubTheme,ae as TypographyTags,pe as theme};
